module.exports = __webpack_public_path__ + "img/RCloudPHP.fe55a83b.png";